import {
    ACTION_CONFIRM_PROMPT_UPDATE_STATE,
    ACTION_CONFIRM_PROMPT_UPDATE_READY_TO_SHOW_STATE,
    ACTION_CONFIRM_PROMPT_UPDATE_CONTENT_STATE,
    ACTION_CONFIRM_PROMPT_RESET_STATE,
    ACTION_CONFIRM_PROMPT_HIDE_PROMPT,
    ACTION_CONFIRM_PROMPT_UPDATE_CONFIRM_STATUS,


    ACTION_CONFIRM_PROMPT_MAKE_READY_TO_SHOW,
    ACTION_CONFIRM_PROMPT_DISPLAY_PROMPT,
    
} from './actionTypes';

const initialState = {
    confirmStatus   :   undefined,
    readyToShow     :   false,
    show            :   false,
    title           :   '',
    message         :   '',
    callbackFunc    :   null,
    buttons         :   undefined
};

export const ExitConfirmPrompt = (state = initialState, action) => {
    switch (action.type) {
        case ACTION_CONFIRM_PROMPT_UPDATE_STATE:
            return {
                ...state,
                confirmStatus   :   action.payload.confirmStatus,
                readyToShow     :   action.payload.readyToShow,
                show            :   action.payload.show,
                title           :   action.payload.title,
                message         :   action.payload.message,
                callbackFunc    :   action.payload.callback
            };
        case ACTION_CONFIRM_PROMPT_UPDATE_READY_TO_SHOW_STATE:
            return {
                ...state,
                readyToShow: action.payload
            }

        case ACTION_CONFIRM_PROMPT_UPDATE_CONTENT_STATE:
            return {
                ...state,
                message: action.payload.message,
                title: action.payload.title,
                buttons: action.payload.buttons
            }
        case ACTION_CONFIRM_PROMPT_UPDATE_CONFIRM_STATUS:
            return {
                ...state,
                confirmStatus: action.payload
            };
        case ACTION_CONFIRM_PROMPT_RESET_STATE:
            return {
                ...state,
                confirmStatus   :   undefined,
                readyToShow     :   false,
                show            :   false,
                title           :   '',
                message         :   '',
                callbackFunc    :   null,
                buttons         :   undefined
            };
        case ACTION_CONFIRM_PROMPT_HIDE_PROMPT:
            return {
                ...state,
                show: false,
                confirmStatus: undefined
            };
        case ACTION_CONFIRM_PROMPT_DISPLAY_PROMPT:
            return {
                ...state,
                show: true,
                callbackFunc: action.payload?.callback
            };
        default:
            return state;
    }
};
